import { render, staticRenderFns } from "./AddImageIcon.vue?vue&type=template&id=c5239e66&scoped=true"
import script from "./AddImageIcon.vue?vue&type=script&lang=js"
export * from "./AddImageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5239e66",
  null
  
)

export default component.exports